<template>
  <span>
    <v-select v-if="!readonly"
      class="d-inline-block select-field-no-child-input mx-2" required dense hide-details
      append-icon="" text="text" value="value" height="14px" style="min-width: 120px;"
      v-model="profileName"
      :items="profileNames"
      @change="onQueryChange"/>
    <span v-else>{{profileNames.find(i => i.value === profileName).text}} </span>
  </span>
</template>

<script>
export default {
  name: "BelongsTo",
  props: {
    onQueryChange: {
      type: Function,
      required: true,
    },
    initialConfig: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      profileName: null,
      profileNames: [{text: '...', value: null}]
          .concat(this.$store.getters.nonDeletedOrExpiredProfiles.map(p => ({text: p.name, value: p.id})))
    }
  },
  created() {
    this.onChangeInitialConfig();
  },
  methods: {
    onChangeInitialConfig() {
      if (this.initialConfig.name) {
        this.profileName = this.initialConfig.name;
      }
    },
    getQuery() {
      return {
        target: 'profiles',
        name: this.profileName
      }
    }
  },
  watch: {
    initialConfig() {
      this.onChangeInitialConfig();
    }
  }
}
</script>

<style scoped>

</style>